var map = {
	"./flag-en.png": 896,
	"./flag-lt.png": 897
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1258;



//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/flag\-.*\.png$
// module id = 1258
// module chunks = 0